/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { DatadogProvider } from '@datadog/openfeature-browser';
import {
  OpenFeature,
  OpenFeatureProvider,
  useBooleanFlagValue,
  useNumberFlagValue,
  useStringFlagValue
} from '@openfeature/react-sdk';
import React, { createElement, useEffect } from 'react';
import { datadogConfig } from './datadogConfig';

export const useFeatureFlag = (flagName: string, defaultValue: boolean) => {
  return useBooleanFlagValue(flagName, defaultValue, { suspend: false });
};

export const useStringFlag = (flagName: string, defaultValue: string): string =>
  useStringFlagValue(flagName, defaultValue, { suspend: false });

export const useNumberFlag = (flagName: string, defaultValue: number): number =>
  useNumberFlagValue(flagName, defaultValue, { suspend: false });

export const FeatureFlagWrapper = (wrappedComponent: React.ComponentType) => {
  const WrappedComponent = wrappedComponent;
  return function WithFeatureFlags(props: any) {
    useEffect(() => {
      OpenFeature.setProvider(
        new DatadogProvider(datadogConfig.providerConfig),
        datadogConfig.evaluationContext
      );
    }, []);
    return createElement(OpenFeatureProvider, null, createElement(WrappedComponent, props));
  };
};
